// @module Ames.RentFromAnywhere.RentFromAnywhere
define("RentFromAnywhere.Checkout.View", [
  "ames_rentfromanywhere_checkout.tpl",

  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",

  "Backbone",
  "LiveOrder.Model",
  "Item.Model",
  "Utils",
], function (
  ames_rentfromanywhere_checkout_tpl,

  RentFromAnywhereSS2Model,

  Backbone,
  LiveOrderModel,
  ItemModel,
  Utils
) {
  "use strict";

  // @class Ames.RentFromAnywhere.RentFromAnywhere.View @extends Backbone.View
  return Backbone.View.extend({
    template: ames_rentfromanywhere_checkout_tpl,

    initialize: function (options) {
    //   var liveOrder = LiveOrderModel.getInstance();
    this.position = options.position || 'top';
    //   var layout = options.container.getComponent("Layout");

    //   liveOrder.cancelableOn("before:LiveOrder.submit", function () {
    //     var deferred = jQuery.Deferred();

    //     try {
    //       var lines = liveOrder.get("lines") || [];

    //       var hasRental = _.some(lines.models, function (line) {
    //         return (
    //           line.get("options") &&
    //           (line.getOption("custcol_custom_price") ||
    //             line.getOption("custcol_custom_rate") ||
    //             line.getOption("custcol_configurable_description"))
    //         );
    //       });

    //       debugger

    //       if (!hasRental) {
    //         // ❌ BLOCK CHECKOUT
    //         deferred.reject({
    //           errorCode: "RENTAL_NOT_ALLOWED",
    //           errorMessage:
    //             "Rental items must be checked out using the rental process. Please review your cart.",
    //         });

    //         // Optional: show message
    //         // layout.showMessage({
    //         //   message:
    //         //     "Rental items cannot be purchased in the normal checkout flow.",
    //         //   type: "error",
    //         //   selector: "Checkout",
    //         // });
    //       } else {
    //         // ✅ ALLOW NORMAL CHECKOUT
    //         deferred.resolve();
    //       }
    //     } catch (e) {
    //       // Fail-safe: never block checkout due to JS error
    //       deferred.resolve();
    //     }

    //     return deferred;
    //   });
    },

    events: {
      'click [data-action="place-rental-order"]': "placeRentalOrder",
    },

    placeRentalOrder: function placeRentalOrder(e) {
      e.preventDefault();
      
      var liveOrder = LiveOrderModel.getInstance();

    },

    bindings: {},

    childViews: {},

    //@method getContext @return Ames.RentFromAnywhere.RentFromAnywhere.View.Context
    getContext: function getContext() {
      //@class Ames.RentFromAnywhere.RentFromAnywhere.View.Context

      return {
        isTop: this.position === 'top',
        isBottom: this.position === 'bottom',
      };
    },
  });
});
